module.exports = "<!DOCTYPE html> <html> <head> <meta charset=UTF-8> <meta name=viewport content=\"width=device-width,initial-scale=1\"> </head> <body> <div class=wrapper> <div> <p class=\"ask-text bell\">Get notified on the latest Carparts.com deals, promotions and new products.</p> </div> <div class=js-button-container> <button id=js-deny class=\"ask-button deny\">No Thanks</button> <button id=js-allow class=\"ask-button allow\">Yes, Subscribe</button> </div> </div> </body> </html> ";


//////////////////
// WEBPACK FOOTER
// ./non-pwa/default-ask.html
// module id = 65
// module chunks = 0